
// axios
import axios from "axios";
// option
import { ClientOption } from "../../../config/clientOption";

export const GetBlogCategories = async () => {
    const { data: response } = await axios.get(`${process.env.REACT_APP_API_URL}blog/categories`, ClientOption);
    return response;
}

export const GetlatestBlog = async () => {
    const { data: response } = await axios.get(`${process.env.REACT_APP_API_URL}blog/latest`, ClientOption);
    return response;
}

export const GetBlogs = async () => {
    const { data: response } = await axios.get(`${process.env.REACT_APP_API_URL}blog/posts`, ClientOption);
    return response;
}
export const GetBlog = async (slug: string) => {
    const { data: response } = await axios.get(`${process.env.REACT_APP_API_URL}blog/posts/${slug}`, ClientOption);
    return response;
}

export const GetBlogTags = async () => {
    const { data: response } = await axios.get(`${process.env.REACT_APP_API_URL}blog/tags`, ClientOption);
    return response;
}